import React from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import { each } from 'lodash';
import axios from 'axios';
import camelcaseKeys from 'camelcase-keys';

import { FilePanel } from 'components/importer/import_requests/file_panel';
import EmptyState from 'components/project/empty_state';

export default class UploadFiles extends React.Component {
  static propTypes = {
    importFiles: PropTypes.array.isRequired,
    onAddFile: PropTypes.func.isRequired,
    onRemoveFile: PropTypes.func.isRequired
  };

  handleDrop = (files) => {
    const { onAddFile } = this.props;
    if (files.length === 0) return;

    each(files, (file) => {
      const formData = new FormData();
      formData.append('upload[file]', file);

      axios.post(
        '/uploads',
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      ).then((response) => {
        const { id, ...file } = camelcaseKeys(response.data);

        file.uploadId = id;
        onAddFile(file);
      });
    });
  }

  render() {
    const { importFiles, onRemoveFile } = this.props;

    return (
      <React.Fragment>
        <FilePanel files={importFiles} onRemove={onRemoveFile} />
        {this.renderDropzone()}
      </React.Fragment>
    );
  }

  renderDropzone() {
    return (
      <React.Fragment>
        <div className="mb-5 uploader">
          <Dropzone
            multiple
            onDrop={this.handleDrop}
          >
            {({ getRootProps, getInputProps }) => (
              <div className="clickable" {...getRootProps()}>
                {this.renderDropBox()}
                <input {...getInputProps()} />
              </div>
            )}
          </Dropzone>
        </div>
      </React.Fragment>
    );
  }

  renderDropBox() {
    const message = <h3 className="mt-0">Upload Files to Import</h3>;
    const subMessage = (
      <h4><div className="btn btn-xs btn-blue mr-2">Choose Files</div> or drop them here to upload</h4>
    );
    return (
      <EmptyState
        imageSrc="/images/importer/upload_icon.svg"
        message={message}
        subMessage={subMessage}
      />
    );
  }
}
